module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/notification.svg?c0b0a6d9";